import { render, staticRenderFns } from "./onboard.vue?vue&type=template&id=05359516"
import script from "./onboard.vue?vue&type=script&lang=js"
export * from "./onboard.vue?vue&type=script&lang=js"
import style0 from "./onboard.vue?vue&type=style&index=0&id=05359516&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports